import "./style.css";
import React from "react";
import axiosInstance from "../../auth/axiosInstance";
import xerror from "./img/xerror.svg";
import { Input } from "../input/input";

function ModalCounts(props) {
  const [idSelected, setIdSelected] = React.useState(null);
  const [data, setData] = React.useState({});
  const [next, setNext] = React.useState(false);

  async function getData() {
    if (!!props.data.id) {
      await axiosInstance(`count/${props.data.id}`)
        .then((res) => {
          setData(res.data);
        })
        .catch((err) => console.log(err));
    }
  }

  React.useEffect(() => {
    if (props.data) {
      getData()
    };
  }, [props.data]);

  const handleCheckboxChange = (event, object) => {
    const { checked } = event.target;
    props.setArrToCheckbox((prevCheckboxes) => {
      if (checked) {
        return [...prevCheckboxes, object];
      } else {
        return [
          ...prevCheckboxes,
          prevCheckboxes.filter((checkbox) => checkbox !== object),
        ];
      }
    });
  };

  React.useEffect(() => {
    if (props.data.id && props.data.id.length > 0) {
      setIdSelected(props.data.id[0]);
    }
  }, [props.data.id]);

  React.useEffect(() => {
    if (idSelected) {
      getData();
    }
  }, [idSelected]);

  return !!props.data ? (
    <section
      style={
        props.show && !!props.data ? { display: "flex" } : { display: "none" }
      }
      className="modal-count"
    >
      <div className="modal-approve-count">
        <div className="modal-approve-count-2">
          <div className="body-modal-ap">
            <div className="close-modal-ap" onClick={() => { props.cancel(); return setNext(false) }}>
              <img src={xerror} alt="close" />
            </div>
            <div className="title-modal-ap">
              {props.type ? <h1>Approve count?</h1> : <h1>Reject count?</h1>}
            </div>
            {
              Object.keys(data).length > 0 &&
              <div className="infos-dc-ap">
                <div className="row-table-estructure-ap">
                  <div className="column-table-estructure-ap">
                    <h1>Data Center</h1>
                    <h3>{data.room.site.site}</h3>
                  </div>
                  <div className="column-table-estructure-ap">
                    <h1>Room</h1>
                    <h3>{data.room.room}</h3>
                  </div>

                  <div className="column-table-estructure-ap">
                    <h1>Date</h1>
                    <h3>{new Date(data.createdAt).toLocaleDateString()}</h3>
                  </div>
                  <div className="column-table-estructure-ap">
                    <h1>Rack Quantity</h1>
                    <h3>{data.total}</h3>
                  </div>
                </div>
              </div>
            }
            {next === false ? (
              <div className="body-racks-cd-ap">
                <div className="racks-added">
                  <h1>Added</h1>
                  <div className="racks-modal-grid">
                    {data.racks && data.racks.length > 0 ? (
                      data.racks.map((rack, index) => {
                        if (rack.status) {
                          return (
                            <div key={rack.id} className='body-content-rack-card-modal'>
                              <Input
                                type='checkbox'
                                props={props.type ? { display: "none" } : {}}
                                onChange={(e) =>
                                  handleCheckboxChange(e, rack.id)
                                } />
                              <div className='content-rack-card-modal'>
                                <div>
                                  <h3 style={{ backgroundColor: '#BDBDBD', borderTopLeftRadius: 8 }}>N {rack.nrack}</h3>
                                  <h3 style={{ backgroundColor: '#BDBDBD', borderTopRightRadius: 8 }}>N Scala {rack.nscala}</h3>
                                </div>
                                {
                                  rack.pduRacks.map(pdu => (
                                    <div>
                                      <h3 style={{ backgroundColor: '#00838D33' }}>{pdu.name}</h3>
                                      <h3 style={{ backgroundColor: '#00838D33' }}>{pdu.circuito}</h3>
                                    </div>
                                  ))
                                }
                                <div>
                                  <h3 style={{ backgroundColor: '#EDEDED' }}>{rack.fileira ? 'Fileira ' + rack.fileira : 'N/A'}</h3>
                                  <h3 style={{ backgroundColor: '#EDEDED' }}>{rack.posicao ? 'Posição ' + rack.posicao : 'N/A'}</h3>
                                </div>
                                <div>
                                  <h3 style={{ backgroundColor: '#EDEDED', borderBottomLeftRadius: 8 }}>{'Potência ' + rack.potenciaContratada ? rack.potenciaContratada : 'N/A'}</h3>
                                  <h3 style={{ backgroundColor: '#EDEDED', borderBottomRightRadius: 8 }}>{'Ocupação ' + rack.ocupacao ? rack.ocupacao : 'N/A'}</h3>
                                </div>
                              </div>
                            </div>
                          )
                        } else {
                          return null
                        }
                      })
                    ) : (
                      <></>
                    )}
                  </div>
                </div>
                <div className="racks-churned">
                  <h1>Churned</h1>
                  <div className="racks-modal-grid">
                    {data.racks && data.racks.length > 0 ? (
                      data.racks.map((rack, index) => {
                        if (!rack.status) {
                          return (
                            <div key={rack.id} className='body-content-rack-card-modal'>
                              <Input
                                type='checkbox'
                                props={props.type ? { display: "none" } : {}}
                                onChange={(e) =>
                                  handleCheckboxChange(e, rack.id)
                                } />
                              <div className='content-rack-card-modal'>
                                <div>
                                  <h3 style={{ backgroundColor: '#BDBDBD', borderTopLeftRadius: 8 }}>N {rack.nrack}</h3>
                                  <h3 style={{ backgroundColor: '#BDBDBD', borderTopRightRadius: 8 }}>N Scala {rack.nscala}</h3>
                                </div>
                                {
                                  rack.pduRacks.map(pdu => (
                                    <div>
                                      <h3 style={{ backgroundColor: '#00838D33' }}>{pdu.name}</h3>
                                      <h3 style={{ backgroundColor: '#00838D33' }}>{pdu.circuito}</h3>
                                    </div>
                                  ))
                                }
                                <div>
                                  <h3 style={{ backgroundColor: '#EDEDED' }}>{rack.fileira ? 'Fileira ' + rack.fileira : 'N/A'}</h3>
                                  <h3 style={{ backgroundColor: '#EDEDED' }}>{rack.posicao ? 'Posição ' + rack.posicao : 'N/A'}</h3>
                                </div>
                                <div>
                                  <h3 style={{ backgroundColor: '#EDEDED', borderBottomLeftRadius: 8 }}>{'Potência ' + rack.potenciaContratada ? rack.potenciaContratada : 'N/A'}</h3>
                                  <h3 style={{ backgroundColor: '#EDEDED', borderBottomRightRadius: 8 }}>{'Ocupação ' + rack.ocupacao ? rack.ocupacao : 'N/A'}</h3>
                                </div>
                              </div>
                            </div>
                          )
                        } else {
                          return null
                        }
                      })
                    ) : (
                      <></>
                    )}
                  </div>
                </div>
              </div>
            ) : (
              <textarea
                className="modal_textarea-count"
                placeholder="Insert reason for churned"
                onChange={props.onChange}
                style={{ resize: "none" }}
              ></textarea>
            )}
          </div>
          <div className="buttons-modal-ap">
            <button
              className="buttons-modal-ap-btn-cancel"
              onClick={() => { props.cancel(); return setNext(false) }}
            >
              <h1> Cancel</h1>
            </button>
            <button
              className="buttons-modal-ap-btn-approve"
              onClick={(e) => {
                if (next) {
                  props.rejeitar(e);
                  setNext(false);
                } else if (props.type) {
                  props.enviar(e);
                } else {
                  setNext(true);
                }
              }}
              style={
                props.type
                  ? { background: "#59975C ", color: "#fff" }
                  : { background: "#B73D3D ", color: "#fff" }
              }
            >
              {next ? (
                <h1> Reject</h1>
              ) : props.type ? (
                <h1>Approve</h1>
              ) : (
                <h1>Next</h1>
              )}
            </button>
          </div>
        </div>
      </div>
    </section>
  ) : (
    <></>
  );
}

export default ModalCounts;
